export default __webpack_public_path__ + "static/media/revealSound.e5c571c9.mp3";